import React from "react";

export const ServiceExpandButton = ({ isExpanded, onExapnd }) => {
  const handleClick = () => {
    onExapnd?.();
  };

  return (
    <div
      className="flex justify-center space-x-2 py-[18px] items-center cursor-pointer"
      onClick={handleClick}
    >
      <i
        className={`fa ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"} text-xs`}
      />
      <span className="font-normal text-[14px] leading-[16px] text-[#1B1B1D]">
        {isExpanded ? "Collapse" : "Service Request"}
      </span>
    </div>
  );
};
